export default {
	state: {
		accountStatus: 'N', // 환불계좌상태 (기본값 N : 미승인) (N : 미승인 / AR : 승인요청 / A : 승인 / AC : 거절)
		statusPrivateAccount: 'N', // 전용계좌 상태 ('N': 발급 전 / 'ACT' : 발급 완료 / 'SUS' : 사용 중지 )
	},
	mutations: {
		SET_ACCOUNT_STATUS: (state, item) => {
			state.accountStatus = item;
		},
		SET_STATUS_PRIVATE_ACCOUNT: (state, type) => {
			state.statusPrivateAccount = type;
		},
	},
	actions: {
		SetAccountStatus({ commit }, statusInfo) {
			commit('SET_ACCOUNT_STATUS', statusInfo);
		},
		SetStatusPrivateAccount({ commit }, statusInfo) {
			commit('SET_STATUS_PRIVATE_ACCOUNT', statusInfo);
		},
	},
	getters: {},
};
